import { connectRouter, routerMiddleware } from 'connected-react-router'
import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import { reducer as form } from 'redux-form'
import createSagaMiddleware from 'redux-saga'
import * as initialStateReducers from '../reducks/initialState'
import { reducer as modals } from '../../legacyLib/common/ZenModal' // TODO: positionsDashboard update from legacy pattern
import { ModalReducer as modal } from '../components/ModalRedux'
import { PopupReducer as popup } from '../components/PopupRedux'
import { SystemErrorReducer as systemError } from '../components/SystemErrorRedux'

import candidateDetails from '../../CandidateDetails/redux/store' // TODO: candidateDetails update from legacy pattern
import candidateList from '@/CandidateListES/redux/store' // TODO: candidateList update from legacy pattern
import interviewRequestsReducks from '../../InterviewRequests/reducks'
import positionsDashboard from '../../PositionsDashboard/redux/store' // TODO: positionsDashboard update from legacy pattern
import sessionHistory from '../containers/SessionHistory/reducks'
import companyExperienceReducks from '../reducks'
import hiringTeamAnalyticsReducks from '../../HiringAnalytics/reducks/hiringAnalytics'
import awaitingKickOffReducks from '../../AwaitingKickOff/reducks/awaitingKickOff'
import sessionReducks from '../reducks/sessions'
import browserHistory from './browserHistory'

const configureStore = (initialState = {}) => {
  const sagaMiddleware = createSagaMiddleware()
  const routingMiddleware = routerMiddleware(browserHistory)

  const middleware = () => {
    if (process.env.NODE_ENV === 'development') {
      const { composeWithDevTools } = require('redux-devtools-extension')
      const { createLogger } = require('redux-logger')

      const composeEnhancers = composeWithDevTools({ trace: true })
      if (process.env.REACT_APP_ENABLE_REDUX_LOGGING === 'true') {
        return composeEnhancers(applyMiddleware(routingMiddleware, sagaMiddleware, createLogger()))
      }
      return composeEnhancers(applyMiddleware(routingMiddleware, sagaMiddleware))
    }

    return applyMiddleware(routingMiddleware, sagaMiddleware)
  }

  const createRootReducer = ({ history, asyncReducers }) =>
    combineReducers({
      router: connectRouter(history),
      form,
      modal,
      modals,
      popup,
      sessionHistory,
      systemError,
      entities: combineReducers(companyExperienceReducks),
      views: combineReducers({
        ...interviewRequestsReducks,
        positionsDashboard_LEGACY: positionsDashboard,
        candidateDetails_LEGACY: candidateDetails,
        candidateList_LEGACY: candidateList,
        sessions: sessionReducks,
        hiringAnalytics: hiringTeamAnalyticsReducks,
        awaitingKickOff: awaitingKickOffReducks,
        ...asyncReducers,
      }),
      static_data: initialStateReducers.staticDataReducer,
    })

  const store = createStore(createRootReducer({ history: browserHistory }), initialState, compose(middleware()))

  store.asyncReducers = {}

  store.registerReducer = (name, reducer) => {
    if (Object.hasOwnProperty.call(store.asyncReducers, name)) return

    store.asyncReducers[name] = reducer
    store.replaceReducer(
      createRootReducer({
        history: browserHistory,
        asyncReducers: store.asyncReducers,
      }),
    )
  }

  store.asyncSagas = []

  store.registerSaga = (name, saga) => {
    if (store.asyncSagas.includes(name)) return

    store.asyncSagas = [...store.asyncSagas, name]
    sagaMiddleware.run(saga)
  }

  return store
}

export default configureStore
